import './scss/style.scss';

import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import PrivateRoute from './services/Permission/PrivateRoute'
import AcessoNegado from './pages/AcessoNegado';
import Descadastrar from './pages/Descadastrar';
import NotFound from './pages/NotFound';
import { Loading } from './components';

// Containers
const Login = React.lazy(() => import('./pages/Login'));
const Default = React.lazy(() => import('./containers/Default'));

class App extends Component {
  render() {
    return (
      <React.Suspense fallback={Loading}>
        <Switch>
          <Route exact path="/login" name="Login Page" render={props => <Login {...props} />} />
          <Route exact path="/404" name="Page 404" render={props => <NotFound {...props} />} />
          <Route exact path="/500" name="Page 500" render={props => <AcessoNegado {...props} />} />
          <Route path="/descadastrar/:hash" name="Decadastrar" render={props => <Descadastrar {...props} />} />
          <PrivateRoute path="*" name="Home" component={props => <Default {...props} />} />
        </Switch>
      </React.Suspense>
    );
  };
}

export default App;
